<template>
  <BasicLayout :left="left" :middle="middle" :right="right">
    <template v-slot:right_view>
      <div class="h100-100">
        <div class="h-scroll h-wrapper-680">
          <div class="h-dialogContainer">
            <form id="callBackForm">
              <div class="row h-row-inputBox">
                <div class="form-group h-col-inputBox">
                  <div class="e-float-input">
                    <div class="h-inputLit">{{$t('Alarm.callBackName')}}:</div>
                    <div class="e-input-group e-control-wrapper">
                      <input :placeholder="$t('Alarm.inputTipCallName')" id="name" name="name" v-model="name" />
                    </div>
                  </div>
                </div>
                <div class="form-group h-col-inputBox">
                  <div class="e-float-input">
                    <div class="h-inputLit">{{$t('Alarm.callBackUrl')}}:</div>
                    <div class="e-input-group e-control-wrapper">
                      <input :placeholder="$t('Alarm.inputTipCallUrl')" id="url" name="url" v-model="url" />
                    </div>
                  </div>
                </div>
              </div>
            
              <div class="row h-row-inputBox">
                <div class="form-group h-col-inputBox">
                  <ejs-checkbox :label="$t('Alarm.able')" ref="smtp" :checked="false" :change="setChecking"></ejs-checkbox>
                </div>
              </div>
            
            </form>
          </div>
        </div>
        <div class="b-t"></div>
        <div class="h-scroll h-system-wrapper-680">
          <div class="h-bottom-btnBox h-system-btnBox">
            <div class="row">
              <div class="col-sm-12 h-col-inputBox">
                <ejs-button ref="apButton" cssClass="e-control e-btn e-lib e-primary e-flat" @click.native="apply">{{$t('System.apply')}}</ejs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from "../../layouts/BasicLayout";
import CustomDialog from "../../components/common/CustomDialog";
import mixin from '../../mixin/mixin';
import {EventBus} from "../../plugins/eventBus";

export default {
  name: "CallBackPage",
  mixins: [mixin],
  data() {
    return {
      left: { show: false, name: "" },
      middle: { show: false, name: "" },
      right: {
        show: true,
        crumb: `${this.$t('Alarm.alarmManage')}/${this.$t("Alarm.callBack")}`
      },
      id: 1,
      name: "三方地址",
      url: "127.0.0.1",
      isVerify: 0, // 是否启用
      inputNames: ['name', 'url'],
      rules: {
        name: { required: true},
        url: { required: true}
      }
    };
  },
  components: {
    BasicLayout,
    CustomDialog
  },
  methods: {
    reset() {
      this.getConfig();
    },
    apply() {
      const url = "/lte/ems/fm/callback/updateCallBack";
      this.formObj = this.validateForm('callBackForm', this.inputNames, this.rules);
      if (!this.formObj.validate()){
        return null;
      };
      this.send(url);
    },
    send(url) {
      const params = {
        id: this.id,
        name: this.name,
        url: this.url,
        enableId: this.isVerify,
      
      };
      this.axios.post(url, params).then(response => {
        this.$loading.hideLoadding();
        if(response.status==200 && response.data){
          EventBus.$emit('toast', {type: 'success', content: `${this.$t('Common.tips.success')}`});
        }else{
          EventBus.$emit('toast', {type: 'error', content: `${this.$t('Common.tips.failure')}`});
        }
      });
      setTimeout(() => {
        console.log(this.$loading.status());
        if(this.$loading.status() == 1){
          this.$loading.hideLoadding();
          EventBus.$emit('toast', {type: 'error', content: `${this.$t('DataManagent.requestTimeOut')}`});
        }
      }, 15000);
    },
    setChecking() {
      let smtp = this.$refs.smtp.ej2Instances.checked;
      if (smtp) {
        this.isVerify = 1;
      } else {
        this.isVerify = 0;
      }
    },
    getConfig() {
      const url = "/lte/ems/fm/callback/queryCallBack";
      this.axios.get(url).then(response => {
        let result = response.data;
        if (result == null || result == "") {
          return null;
        }
        if (response && response.status === 200) {
          const resultVal = response.data.resultVal;
          this.id = resultVal.id;
          this.name = resultVal.name;
          this.url = resultVal.url;
          this.isVerify = resultVal.enableId;
          if(this.isVerify==1) {
            this.$refs.smtp.ej2Instances.checked = true;
          }else if(this.isVerify==0) {
            this.$refs.smtp.ej2Instances.checked = false;
          }
        }
        
      });
    }
  },
  mounted() {
    this.formObj = this.validateForm('callBackForm', this.inputNames, this.rules);
    this.getConfig();
  }
};
</script>

<style>

</style>
